export enum AuthMutationTypes {
  'SET_GENERATE_TOKEN' = 'SET_GENERATE_TOKEN',
  'SET_AUTH_USER' = 'SET_AUTH_USER',
  'SET_USER_VERIFICATION' = 'SET_USER_VERIFICATION',
  'SET_USER_INFO' = 'SET_USER_INFO',
  'SET_FIRST_LOGIN' = 'SET_FIRST_LOGIN',
  'SET_USER_VERIFICATION_PHONE'= 'SET_USER_VERIFICATION_PHONE',
  'SET_LANGUAGE_LOADED' = 'SET_LANGUAGE_LOADED',
  'SET_DEFAULT_SHIP_TO' = 'SET_DEFAULT_SHIP_TO',
  'SET_USER_NEW_INFO' = 'SET_USER_NEW_INFO',
  'SET_WIDGET' = 'SET_WIDGET',
  'SET_USER_RE_VALIDATE' = 'SET_USER_RE_VALIDATE'
}
